"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorStringToHex = void 0;
var colorStringToHex = function (v) {
    if (v[0] !== '#') {
        throw new Error("color not valid [" + v + "]: must start with #");
    }
    var sub = v.substring(1);
    if (sub.length !== 6 && sub.length !== 3) {
        throw new Error("color not valid [" + v + "]: incorrect length");
    }
    var finalStr = sub.length === 6
        ? sub
        : sub + sub;
    return Number.parseInt(finalStr, 16);
};
exports.colorStringToHex = colorStringToHex;
